import createCache from "@emotion/cache";
import { EmotionCache } from "@emotion/cache";

// see: https://github.com/mui/material-ui/tree/master/examples/nextjs
export default function createEmotionCache(): EmotionCache {
  // Do not change the "prepend" to true because we want the Emotion (MUI) styles to be applied after the "globals.css".
  // For example to override the size of icons coming from "material-design-icons".
  return createCache({ key: "css", prepend: false });
}
